<script>
    import { onDestroy, onMount } from "svelte";
    import toast from "svelte-french-toast";
    import { navigate } from "svelte-routing";
    import { Moon } from "svelte-loading-spinners";
    import { link } from "svelte-routing";
    import { settings } from "../../stores/settingsStore";
    import Button from "../../components/Button/Button.svelte";
    import ButtonPromise from "../../components/Button/ButtonPromise.svelte";
    import { sendConfirmationEmail } from "../../services/membershipService";

    const urlParams = new URLSearchParams(window.location.search);

    let membershipId = urlParams.get("id");
    let maximumPayment;
    let minPayment;
    let amount;
    let payment = undefined;
    let isUGS = undefined;
    let gotoPayment = false;
    let isTransfer = false;
    let timer;
    let confirmationEmailPromise = null;
    let unsubscribeSettings;

    function handleInput(value) {
        clearTimeout(timer);

        timer = setTimeout(() => {
            if  (!value || value < minPayment) {
                amount = minPayment
                return;
            }

            if  (value > maximumPayment) {
                amount = maximumPayment
                return;
            }

            if (value < minPayment) {
                amount = minPayment;
                return;
            }

            amount = value;
        }, 200);
    }

    function handleBankTransferPayment(membershipId) {
        confirmationEmailPromise = (async () => {
            try {
                await sendConfirmationEmail(membershipId);
            } catch (_e) {

            } finally {
                confirmationEmailPromise = null;
                isTransfer = true
            }
        })();
    }

    onMount(async () => {
        isUGS = JSON.parse(localStorage.getItem(process.env.IS_UGS)).isUGS;

        if (isUGS === undefined || isUGS == null) {
            toast("Completa l'iscrizione prima di accedere a questa pagina");
            navigate("/", {replace: true});
        }

        unsubscribeSettings = settings.subscribe((settings) => {
            if (!settings) {
                return;
            }

            maximumPayment = settings.maximumPayment;
            minPayment = isUGS ? settings.minimumPaymentUGS : settings.minimumPaymentNotUGS;
            payment = minPayment;
            amount = minPayment;
        })
    });

    $: isAmountInvalid = amount < minPayment || amount > maximumPayment

    onDestroy(unsubscribeSettings);

    async function goToNumiaPayment(membershipId, amount) {
        navigate(`${process.env.API_URL}/v1/payments/init/${membershipId}?amount=${amount}`);
    }

</script>

{#if membershipId}
    <div class="container mx-auto w-full md:bg-none">
        <div class="flex flex-col content-center gap-4 items-center select-none h-full w-full">
            <div class="title-red font-bold w-full text-center">
                Pagamento quota di adesione
            </div>

            {#if !gotoPayment && !isTransfer}
                <div class="w-full md:w-8/12 flex flex-col gap-7 mt-2">
                    <div class="text-3xl font-450 text-center">
                        Quanto vuoi versare per la tua quota di adesione?
                    </div>
                    <div class="text-center text-2xl">
                        Puoi aumentare la quota minima di iscrizione di {minPayment ?? ""}€, contribuirai così a finanziare le iniziative politiche che decideremo insieme di mettere in campo.
                    </div>
                </div>

                <div class="flex flex-col pt-8 w-full items-center">
                    <div class="h-24 w-80 text-2xl number text-center text-blueGray-800 flex justify-center items-center">
                        {#if payment === undefined}
                            <Moon size="40" color="#ef3f3e" unit="px" duration="0.5s" />
                        {:else}
                            <input
                                id="payment"
                                type="number"
                                on:input|preventDefault={(value) => handleInput(value?.target?.value)}
                                bind:value={amount}
                                step="5"
                                style="font-size: 6rem"
                                class="border-none text-center inputPayment w-full bg-none select-none focus:outline-none"
                            >
                            <div class="text-4xl">€</div>
                        {/if}
                    </div>
                    <div class="md:w-5/12 w-full gap-2 md:gap-7 h-24 flex justify-between items-center">
                        <div class="w-24 text-center text-xl">
                            {#if amount === undefined}
                                <Moon size="10" color="#ef3f3e" unit="px" duration="0.5s" />
                            {:else}
                                <div class="text-2xl">
                                    {minPayment}
                                </div>
                            {/if}
                        </div>
                        <input
                            id="default-range"
                            type="range"
                            bind:value={amount}
                            min={minPayment}
                            max={maximumPayment}
                            step="5"
                            class="w-full h-2 range-lg bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
                        >
                        <div class="w-24 text-center text-xl">
                            {#if !amount}
                                <Moon size="10" color="#ef3f3e" unit="px" duration="0.5s" />
                            {:else}
                                <div class="text-2xl">
                                    {maximumPayment}
                                </div>
                            {/if}
                        </div>
                    </div>
                </div>

                <div class="flex flex-col gap-6 items-center w-full">
                    <div class="w-full md:w-6/12 text-xl text-center">
                        Procedendo con l'iscrizione a Sinistra Italiana accetti
                        “<a
                            use:link
                            href="/policy"
                            target="_blank"
                            class="red-si bg-none cursor-pointer"
                        >
                            Termini e condizioni d’utilizzo
                        </a>”.
                        Se non accetti non ti sarà possibile procedere con l'iscrizione.
                    </div>

                    <div class="flex flex-col gap-7 mb-2 md:flex-row">
                        <Button
                            handleClick="{() => goToNumiaPayment(membershipId, amount)}"
                            buttonClass="w-64 h-16 text-lg font-450 bg-lightBlue-500 rounded font-bold text-white"
                            content="Pagamento online"
                            isDisabled="{isAmountInvalid}"
                        />

                        <ButtonPromise
                            handleClick="{() => handleBankTransferPayment(membershipId)}"
                            promise="{confirmationEmailPromise}"
                            buttonClass="w-64 h-16 text-lg font-450 bg-lightBlue-500 rounded font-bold text-white"
                            content="Pagamento con bonifico"
                            isDisabled="{isAmountInvalid}"
                        />
                    </div>
                </div>
            {/if}

            {#if gotoPayment}
                <div class="w-8/12 flex flex-col gap-7 mt-2">
                    <div class="text-3xl font-450 text-center">
                        Seleziona un metodo di pagamento e inserisci i tuoi dati per completare l'iscrizione
                    </div>
                </div>
            {/if}

            {#if isTransfer}
                <div class="w-8/12 flex flex-col gap-7 mt-4">
                    <div class="text-3xl font-450 text-center">
                        Per completare il pagamento con bonifico utilizza queste informazioni
                    </div>
                    <div class="p-4 h-full w-full border border-gray-200 shadow-md break-words">
                        <div class="text-2xl">
                            Indica nella causale di pagamento nome e cognome seguiti dal tuo codice utente
                        </div>
                        <div class="text-2xl">
                            <span class="font-bold">- BENEFICIARIO:</span> Sinistra Italiana - BANCO BPM - Fil. di Piazza di Montecitorio, Roma
                        </div>
                        <div class="text-2xl">
                            <span class="font-bold">- IBAN:</span> IT70F0503403264000000002286
                        </div>
                        <div class="text-2xl">
                            <span class="font-bold">- SWIFT:</span> BAPPIT21P23
                        </div>
                    </div>
                </div>
            {/if}
        </div>
    </div>
{:else}
    <div class="container mx-auto w-full md:bg-none">
        <div class="flex flex-col content-center items-center select-none h-full w-full">
            <div class="text-3xl font-bold w-full text-center">
                ID del sottoscrittore mancante, non posso procedere al pagamento.
            </div>
        </div>
    </div>
{/if}

<style>
    input[type="number"]
    {
        background: transparent;
        border: none;
        outline: none;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    input[type=number] {
        -moz-appearance:textfield; /* Firefox */
    }
</style>